module.exports = __webpack_public_path__ + "media/images/frontend/normas-esenciales-93162f23ca1312e24c2264e589e0dd58.svg";